import React, { useState } from 'react';
import { Stepper } from '@operations/shared';
import AllUnidentifiedCollection from './AllUnidentifiedCollection';
import AssignUnidentifiedCollection from './AssignUnidentifiedCollection';

export const ViewUnidentifiedCollection: React.FC = () => {
    const [componentSteps] = useState([
        {
            title: 'View Unidentified Collection',
            content: <AllUnidentifiedCollection />,
            id: 0,
        },
        {
            title: 'Assign unidentified collection',
            content: <AssignUnidentifiedCollection />,
            id: 1,
        },
    ]);

    return (
        <>
            <Stepper componentSteps={componentSteps} />
        </>
    );
};

